import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useOpenRecommendedExpress } from './RecommendedExpressProvider';

export default function RecommendedExpressMenuItem() {
  const open = useOpenRecommendedExpress();
  return (
    <MenuItem className="rec-express-menu-item" onClick={open}>
      <ListItemIcon>
        <ConfirmationNumberIcon color="warning"/>
      </ListItemIcon>
      <Typography flex="1 1 auto">
        <FormattedMessage id="RECOMMENDED_EXPRESS_BUTTON"/>
      </Typography>
      <ChevronRightIcon fontSize="small" color="disabled"/>
    </MenuItem>
  );
}
